import styled from "styled-components";
import { FlexStream, } from "@bracket/ui";
import { useWallet, } from "@bracket/platform/store";
import { AddressButton, } from "./AddressButton";
import { BrktBalancePill, } from "./BrktBalance";
import { QuickNavItems, } from "./QuickNavItems";





export const SettingsBar = () => {

	const { address, anonymous, } = useWallet();

	return (
		<SettingsBarContainer>
			{ address && !anonymous && <AddressButton /> }
			{ address && !anonymous && <BrktBalancePill /> }
			<QuickNavItems justify="flex-end" />
		</SettingsBarContainer>
	);
};


const SettingsBarContainer = styled(FlexStream)`
	align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
`;

